<template>
  <div class="py-6">
    <div v-if="authStore.isAdmin" class="max-w-7xl px-4 sm:px-6 md:px-8">
      <h1 class="mb-3 text-2xl font-semibold text-gray-900">
        Gemeentebanen's {{ t('dashboard.title') }}
      </h1>

      <p class="text-sm">
        <span class="text-gray-600">{{ t('dashboard.period') }}: </span>
        <span class="text-indigo-600"
          >{{ format(dashboardStore.startDate, 'dd/MM/yyyy') }} -
          {{ format(dashboardStore.endDate, 'dd/MM/yyyy') }}</span
        >
      </p>

      <TabNavigation storeName="dashboard" :tabs="tabs" class="mb-10" />

      <div v-if="activeTab === 'dashboard-vacancies'">
        <VacancyCharts />
      </div>

      <div v-if="activeTab === 'dashboard-candidates'">
        <p class="text-gray-700">COMING SOON!</p>
        <!-- <CandidateCharts /> -->
      </div>

      <div v-if="activeTab === 'dashboard-jobalerts'">
        <JobAlertCharts />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router'
import { useAuthStore } from '../store/authStore'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import TabNavigation from '../components/TabNavigation.vue'
import VacancyCharts from '../components/dashboard/VacancyCharts.vue'
import CandidateCharts from '../components/dashboard/CandidateCharts.vue'
import JobAlertCharts from '../components/dashboard/JobAlertCharts.vue'
import { format } from 'date-fns'
import { useDashboardStore } from '../store/dashboardStore'

const { t } = useI18n({
  inheritLocale: true,
  useScope: 'global',
})

const route = useRoute()
const authStore = useAuthStore()
const dashboardStore = useDashboardStore()

const tabs = [
  'dashboard-vacancies',
  'dashboard-jobalerts',
  'dashboard-candidates',
]
const activeTab = computed(() => {
  return route.name
})
</script>
